import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { happyIcon } from '../icons';
import { getKeyHandler } from '../structure/FlowForm';
import Icon from './Icon';
import './ImageButton.css';
const ImageButton = ({ focusId, icon, iconFit = 'circle', focussable = 'sideway', size = 'medium', onClick, type = 'major', turn = 0, disabled = false, mediaSelection = undefined, sidewaysBehaviour = 'both', className, iconUrl, onKeyPress, title }) => {
    const [clicked, setClicked] = React.useState(false);
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour,
        onAction: () => {
            setClicked(true);
            setTimeout(() => setClicked(false), 200);
            onClick === null || onClick === void 0 ? void 0 : onClick(true);
        },
        defaultHandler: onKeyPress
    });
    return (_jsxs("button", { id: focusId, className: `imageButton${mediaSelection ? ` ${mediaSelection}` : ''} ${iconFit} ${size}${focussable != 'normal' && !disabled ? ' flowFocussable' : ''}${focussable == 'sideway' && !disabled ? ' sidewayFocus' : ''} ${type} ${clicked ? 'clicked' : 'unclicked'}${turn ? ' turn' + turn : ''} ${disabled ? 'disabled' : 'enabled'} ${className ? ' ' + className : ''}`, tabIndex: disabled ? -1 : 0, title: title, onClick: (ev) => { ev.preventDefault(); ev.stopPropagation(); onClick === null || onClick === void 0 ? void 0 : onClick(false); }, onKeyDown: handleKeyDown, children: [_jsx("div", { className: 'background' }), iconUrl ? _jsx("img", { src: iconUrl }) : _jsx(Icon, { icon: icon || happyIcon, size: size })] }));
};
export default ImageButton;
